import { getCurrentAppBasePath } from './getCurrentAppBasePath';

export default function getCurrentModuleBasePathWithSearchQuery() {
    const { searchQuery, pathPrefix } = getCurrentAppBasePath();
    return `${pathPrefix}${searchQuery}`;
}
